import { UserRowRoleType } from '@modules/users/store/types';
import { UserState, UserType } from 'generated/graphql';
import { mapUserTypeToUserRowRoleType } from './mapUserTypeToUserRowRoleType';

export const getUserRowRoleFromUserTypeAndState = (
  userType: UserType,
  userState: UserState,
): UserRowRoleType => {
  if (userState === UserState.Suspended) {
    return UserRowRoleType.Suspended;
  }

  return mapUserTypeToUserRowRoleType(userType) ?? UserRowRoleType.Editor;
};
